/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// Fix: Prevent duplicate Pinterest pagevisit events on the PDP.
// The theme calls history.replaceState when a variant is selected, which the Pinterest
// pixel intercepts and misreads as a new page navigation, firing a second pagevisit.
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    if (typeof window.pintrk !== 'function') return;

    var _pintrk = window.pintrk;
    var suppressNextPageVisit = false;

    window.pintrk = function() {
      if (suppressNextPageVisit && arguments[0] === 'track' && arguments[1] === 'pagevisit') {
        suppressNextPageVisit = false;
        return;
      }
      return _pintrk.apply(this, arguments);
    };
    window.pintrk.queue = _pintrk.queue;

    document.addEventListener('variant:changed', function() {
      suppressNextPageVisit = true;
      setTimeout(function() { suppressNextPageVisit = false; }, 500);
    });
  });
})();